import React, { Component } from 'react';

export default class About extends Component {

  render() {

    return (
      <div className='about-div'>
        <div className="container">
          <div className='sub-head pt-5'>About us</div>
          <div className='about-desc'>
            Maeve Lifestyle is dedicated to curating
            high-quality, timeless pieces that embody
            elegance and sophistication. We prioritize
            quality over quantity, offering only the
            finest selections to elevate your lifestyle.
            Discover luxury with Maeve—where
            excellence meets refinement.
          </div>
        </div>
      </div>
    )
  }
}
